export const getMainState = (state) => state.ownership.mainState;
export const getSubCategory = (state) => state.ownership.subCategory;
export const getLimitData = (state) => state.ownership.limitData;
export const getOrderSeqArr = (state) => state.ownership.orderSeqArr;
export const getOsid = (state) => state.ownership.osid;
